import SelectLabelFormatter from '../SelectLabelFormatter'

import DurationWFFMDataExchange from '@/services/DurationWFFMDataExchange'

/**
 * A mixin adding duration editing logic and data
 */
export default {
  mixins: [
    SelectLabelFormatter,
  ],
  data () {
    return {
      dx: { duration: new DurationWFFMDataExchange(this.form) },
      popups: { duration: false },
      durations: [],
    }
  },
  created () {
    this.durations = this.dx.duration.data
  },
  computed: {
    selectedDurationLabel () {
      return 'Długość pobytu'
    },
    selectedDurationValue () {
      return `${this.durations.range.split(':').join('-')} dni`
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/search/logic/Duration.js